import { motion } from "framer-motion";

interface InsightValidationProps {
  onNext: () => void;
  productsTried: string[];
  age: string;
}

const getAgeLabel = (age: string) => {
  if (!age) return "50+";
  const start = age.split("–")[0];
  return `${start}+`;
};

const getMessage = (productsTried: string[], age: string) => {
  const ageLabel = getAgeLabel(age);
  if (productsTried.length >= 3) {
    return {
      headline: "Je hebt al zóveel geprobeerd.",
      sub: "En toch voelde het alsof niets écht werkte. Dat is niet jouw schuld. Dat is een probleem met de methode.",
      stat: "83%",
      statText: `van vrouwen ${ageLabel} heeft dezelfde frustratie`,
    };
  }
  return {
    headline: "Je bent niet de enige.",
    sub: "De meeste vrouwen proberen product na product, zonder echt resultaat. Daar is een reden voor.",
    stat: "73%",
    statText: `van vrouwen ${ageLabel} heeft dezelfde ervaring`,
  };
};

const InsightValidation = ({ onNext, productsTried, age }: InsightValidationProps) => {
  const msg = getMessage(productsTried, age);

  return (
    <div className="text-center">
      {/* Seeding card — plants the belief "it's the method, not you" */}
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="insight-card mb-5 md:mb-8"
      >
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.15 }}
          className="text-4xl md:text-6xl font-serif font-bold text-gradient-gold mb-6 md:mb-10 leading-tight pt-2 md:pt-4"
        >
          {msg.stat}
        </motion.div>
        <p className="text-foreground/80 font-sans text-lg md:text-xl mb-4 md:mb-6">
          {msg.statText}
        </p>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.35 }}
        >
          <h3 className="text-2xl md:text-4xl font-serif font-medium text-foreground mb-3 md:mb-4">
            {msg.headline}
          </h3>
          <p className="text-foreground/80 font-sans text-lg md:text-xl leading-relaxed max-w-md mx-auto">
            {msg.sub}
          </p>
        </motion.div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.7 }}
      >
        <button onClick={onNext} className="btn-cta">
          Laat me zien waarom
        </button>
      </motion.div>
    </div>
  );
};

export default InsightValidation;
